import {  ListSubheader   } from "@mui/material";
import { ShiftSelection } from "./ShiftSelection";
import { DayIcon } from "./icons/DayIcon";
import { SwingIcon } from "./icons/SwingIcon";
import { GraveIcon } from "./icons/GraveIcon";



const ShiftWeekHeader = ({ scheduledHours, index, dolStatus }) => {
  return (
    <ListSubheader className="m-0 sticky top-[42px] z-20 bg-white px-[10px] pt-[25px] pb-[6px]">
      <ShiftSelection
        scheduledHours={scheduledHours}
        index={index}
        dolStatus={dolStatus}
      />

      <div className="mt-2 flex w-full flex-col items-center justify-center">
        <div className="ml-[10px] flex w-full items-center justify-center">
          <div className="basis-[54px] shrink-0 grow-0" />

          <div className="flex w-full flex-1 items-center justify-around">
            <div className="flex min-w-[64px] items-center justify-center gap-1">
              <DayIcon />
              <span className="text-[15px] font-medium leading-[1.2] text-[var(--color-black)]">
                Day
              </span>
            </div>

            <div className="flex min-w-[64px] items-center justify-center gap-1">
              <SwingIcon />
              <span className="text-[15px] font-medium leading-[1.2] text-[var(--color-black)]">
                Swing
              </span>
            </div>

            <div className="flex min-w-[64px] items-center justify-center gap-1">
              <GraveIcon />
              <span className="text-[15px] font-medium leading-[1.2] text-[var(--color-black)]">
                Grave
              </span>
            </div>
          </div>
        </div>
      </div>
    </ListSubheader>
  );
};

export { ShiftWeekHeader };
